import React, { useContext } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import AppTheme from "../../AppTheme";

import ReflectionContext from "../ReflectionContext";
import MoodsHelper from "../../common/mood/MoodsHelper";
import {
  durationToHHmm,
  isSleep,
  isJob,
  hasItems,
} from "../../../../helpers/utils";

import styles from "./hoursStyles";
import appStyles from "../../../appStyles";

export default function ReflectionHours({
  item,
  day,
  dayIndex,
  level,
  isSwipeOpen,
}) {
  const {
    onHoursSelected = () => {},
    onHoursLongPressed = () => {},
    showTutorials,
    showReflectionTutorials,
    tutorialStep,
    isReportMode,
    header = { days: [] },
  } = useContext(ReflectionContext) || {};

  const itemDay = header.days[dayIndex]?.day;

  // ------------------------------------- METHODS -------------------------------------
  const getDayJournal = (c_day, timeline = {}) => {
    // Either Reflection gem or Track journal
    return c_day.gem || timeline.gems?.find((g) => g.day === itemDay);
  };

  const getParentMoodFromKids = (elem) => {
    if (!hasItems(item.children)) return -1;

    let mood = -1;
    elem.children.forEach((c) => {
      if ((c.isSelected || !isReportMode) && hasItems(c.days)) {
        const gem = getDayJournal(c.days[dayIndex], c.timeline);

        if (gem?.mood > mood) {
          mood = gem.mood;
        }
      }
    });

    return mood;
  };

  const onHoursPressed = () => {
    if (isSwipeOpen) return;

    if (
      (showTutorials || showReflectionTutorials) &&
      // Last week: On last step allow user to edit everything
      !(showTutorials && (tutorialStep >= 10 || highlightStyle)) &&
      // Reflection tutorials
      !(showReflectionTutorials && highlightStyle && tutorialStep == 3)
    ) {
      return;
    }

    onHoursSelected(item, day, dayIndex, level);
  };

  const onHoursLongPress = () => {
    if (showTutorials) return;
    onHoursLongPressed(item, day, dayIndex);
  };
  // ------------------------------------- END METHODS -------------------------------------

  let { minutes } = durationToHHmm(day.hours) || {};
  let hours = Math.floor(day.hours);
  if (!isReportMode) {
    hours = hours < 100 ? hours : Math.round(Math.round(day.hours * 100) / 100);
    minutes = hours > 100 ? 0 : minutes;
  }

  // GEM
  let gemTextColor = AppTheme.almostBlack;
  let gemStyle = {};
  if (!showReflectionTutorials) {
    const gem = getDayJournal(day, item.timeline);

    gemTextColor =
      MoodsHelper.getTextColorByMood(gem?.mood) || AppTheme.almostBlack;

    if (gem) {
      gemStyle = MoodsHelper.geReflectionGemStyle(gem.mood);

      // Add unfilled box to signify child Journals on a parent in Reflection
    } else if (item.isSelected || !isReportMode) {
      const mood = getParentMoodFromKids(item);

      if (mood > -1) {
        gemStyle = MoodsHelper.geReflectionGemStyle(mood, true);
      }
    }
  }

  // Last week: Tutorials
  let highlightStyle =
    showTutorials &&
    ((tutorialStep == 1 && dayIndex == 1 && isSleep(item.name)) ||
      (tutorialStep == 3 && dayIndex == 0 && isJob(item.name, true)))
      ? appStyles.highlightRound
      : null;

  // Reflection: Tutorials
  if (
    showReflectionTutorials &&
    tutorialStep >= 3 &&
    isSleep(item.name)
    //&& hasItems(item.children)
  ) {
    highlightStyle = appStyles.highlightRound;
  }

  return (
    <TouchableOpacity
      onPress={onHoursPressed}
      onLongPress={onHoursLongPress}
      style={styles.tile}
    >
      <View style={gemStyle}>
        <View style={[styles.numbers, highlightStyle]}>
          <Text
            title={day.gem?.text}
            style={[
              styles.hoursText,
              { color: gemTextColor },
              //day.is_modified && { color: AppConfig.MANA_PURPLE },
            ]}
          >
            {hours}
          </Text>
          {minutes > 0 ? (
            <Text
              title={day.gem?.text}
              style={[
                styles.minutesText,
                { color: gemTextColor },
                //day.is_modified && { color: AppConfig.MANA_PURPLE },
              ]}
            >
              {minutes}
            </Text>
          ) : null}
        </View>
      </View>
    </TouchableOpacity>
  );
}
